import TrackEventLink from '../track-event-link/TrackEventLink';
import { Icon } from '@sb1/ffe-icons-react';
import arrowRight from '@sb1/ffe-icons/icons/open/300/md/keyboard_arrow_right.svg';
import styles from './card.module.less';
import { Heading4 } from '@sb1/ffe-core-react';

export const Card = ({ title, shadow = false, hideCaret = false, children, to }) => {
    const CardBase = to ? TrackEventLink : 'div';

    return (
        <CardBase
            to={to}
            className={[styles.cardContainer, shadow ? styles.shadow : '', to ? styles.link : ''].join(' ')}
        >
            <div className={styles.titleWrapper}>
                <Heading4 className={styles.title}>{title}</Heading4>
                {to && !hideCaret && <Icon fileUrl={arrowRight} className={styles.caret} />}
            </div>
            {children}
        </CardBase>
    );
};
